import httpApi from '../hooks/api/httpApi';

const updateAddress = (addressId, data) => {
    return httpApi.put('/api/v1/addresses/' + addressId, data);
};

const createNewAddresses = (data) => {
    return httpApi.post('/api/v1/addresses', data);
};

const deleteAddresses = (addressId) => {
    return httpApi.del('/api/v1/addresses/' + addressId);
};

export default {
    updateAddress,
    createNewAddresses,
    deleteAddresses
};
